package earth.worldwind.render

enum class FontWeight { NORMAL, BOLD, ITALIC }